<template>
  <div class="">
    <Transition  name="fade">
      <div v-if="utils.loading"
           class="fixed flex flex-col items-center justify-center h-screen w-full bg-white z-[9999]"
           @click="utils.loading = false">
        <BaseIcon class="text-black w-[113px]" name="logo"/>
      </div>
    </Transition>

    <NuxtLayout>
      <NuxtPage />
    </NuxtLayout>
  </div>

</template>

<script lang="ts" setup>
import {useUtilStore} from "~/store/util"
import Clarity from "@microsoft/clarity"

const utils = useUtilStore()
const device = useDevice()

const appConfig = useAppConfig()
Clarity.init(appConfig.clarity)

onMounted(() => {
  document.fonts.ready.then(() => {
    utils.loading = false
  });

  if(device.isSafari) {
    window.addEventListener('pageshow',
      function (evt) {
        if (evt.persisted) {
          setTimeout(function () {
            window.location.reload()
          }, 10)
        }
      },
      false,
    );
  }
})
</script>
<style>
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-enter-active {
  opacity: 1;
}
.fade-leave-to {
  opacity: 0;
}
</style>
